import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { TripAttributesGps } from '../dto/visit-gps.interface';

/**
 * Trip Cell Renderer
 *
 * Renders route, user, and responsible information using UserRouteDisplayComponent
 *
 * @example
 * ```typescript
 * {
 *   field: 'id',
 *   headerName: 'Viaje',
 *   cellRenderer: TripCellRendererComponent,
 *   minWidth: 250
 * }
 * ```
 */
@Component({
  selector: 'app-trip-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    <div
      class="flex items-center px-3 cursor-pointer"
      [ngClass]="{ 'underline': params.data?.id }"
      (click)="params.data?.id && goToTravel(params.data)"
      [matTooltip]="params.data?.id ? 'Ir al viaje' : ''"
    >
      <span>{{ params.data?.id }}</span>
      <mat-icon
        *ngIf="params.data?.id"
        class="ml-2 icon-size-3 hover:animate-bounce"
        [svgIcon]="'heroicons_outline:rocket-launch'"
        style="color:rgb(0, 0, 0);"
      ></mat-icon>
    </div>
  `,
})
export class TripCellRendererComponent implements CellRenderer<TripAttributesGps> {
  @Input() params!: CellRendererParams<TripAttributesGps>;

  constructor(private router: Router) {}

  goToTravel(element: TripAttributesGps): void {
    if (element?.id) {
      const queryParams = { tripId: element.id };
      const urlTree = this.router.createUrlTree(
        ['monitor', 'principal-screen'],
        { queryParams }
      );
      const absoluteUrl = window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, '_blank');
    }
  }
}
